<!--
Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
Unauthorized use, copying, distribution, displaying, or public performance
of this file, via any medium, is strictly prohibited. All information
contained herein is proprietary and confidential and may not be shared
with any third party without the express written consent of Reciprocity, Inc.
-->

<template>
  <generic-card
    cancel-title="Open in ServiceNow"
    cancel-variant="outline-primary"
    ok-title="Close"
    @ok="$emit('close')"
    @cancel="openInServiceNow"
  >
    <template slot="modal-header">
      <!-- Leaving the slot completely empty would render defaults -->
      <span class="d-none" />
    </template>
    <div class="servicenow-task">
      <div class="row">
        <div class="col-md-8 main-column">
          <h4 class="title">{{ task.short_description }}</h4>
          <div class="description">
            {{ task.description }}
          </div>
          <task-comments
            :comments="task.comments"
            :adding-comment="addingComment"
            @addComment="$emit('addComment', $event)"
          />
        </div>

        <div class="col-md-4 side-column">
          <div class="property"><strong>Number:</strong> {{ task.number }}</div>
          <div class="property"><strong>State:</strong> {{ task.state_display }}</div>
          <div class="property"><strong>Primary assignee:</strong> {{ task.primary_assignee }}</div>
          <div class="property">
            <div>
              <strong>Additional assignees:</strong>
            </div>
            <div v-for="assignee in task.additional_assignees" :key="assignee" class="property">
              {{ assignee }}
            </div>
          </div>
          <div class="property">
            <strong>Attachments:</strong>
            <task-attachments
              :attachments="task.attachments"
              :audit-id="task.info.audit_id"
              :task-id="task.info.task_id"
            />
          </div>
        </div>
      </div>
    </div>
  </generic-card>
</template>

<script>
import GenericCard from '@/components/cards/GenericCard.vue';

import TaskComments from './TaskComments.vue';
import TaskAttachments from './TaskAttachments.vue';

export default {
  name: 'ServiceNowTask',
  components: {
    GenericCard,
    TaskComments,
    TaskAttachments,
  },
  props: {
    task: {
      type: Object,
      required: true,
    },
    addingComment: {
      type: Boolean,
      required: true,
    },
    openInServiceNowUrl: {
      type: String,
      default: null,
    },
  },
  methods: {
    openInServiceNow() {
      window.open(this.openInServiceNowUrl, '_blank');
    },
    containsKey(obj, key) {
      return Object.keys(obj).includes(key);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/design/colors';

.servicenow-task {
  .title {
    font-weight: bold;
    margin: 0.5rem 0 1rem;
  }

  .description {
    flex: 1;
    min-height: 10rem;
  }

  .main-column {
    display: flex;
    flex-direction: column;
  }

  .side-column {
    border-left: 1px solid $color-athens-gray;
    margin: -1rem 0;
    padding: 1.5rem;
  }

  .property:not(:last-child) {
    margin-bottom: 1.5rem;
  }
}
</style>
